// #region scroll buffer function
// scroll buffer jQuery plugin from https://stackoverflow.com/questions/7392058/more-efficient-way-to-handle-window-scroll-functions-in-jquery;
(function($) {
    var uniqueCntr = 0
    $.fn.scrolled = function(waitTime, fn) {
        if (typeof waitTime === 'function') {
            fn = waitTime
            waitTime = 30
        }
        var tag = 'scrollTimer' + uniqueCntr++
        this.scroll(function() {
            var self = $(this)
            var timer = self.data(tag)
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(function() {
                self.removeData(tag)
                fn.call(self[0])
            }, waitTime)
            self.data(tag, timer)
        })
    }
})(jQuery)
// #endregion

jQuery(document).ready(function($) {    

    $('.home-partner .partner-blocks .cols .col .block .text').matchHeight();

    // #region shared variables
    var getUrl = window.location

    // make sure slide_duration is synced with SCSS variable in base/_motion
    var slide_duration = 6500

    // scroll variables
    var sPos = 0
    var stuck = false
    var lastScroll = 0
    // #endregion

    // #region sliders
    $('.single-slider').slick({
        dots: true,
        infinite: true,
        autoplay: true,
    })
    // #endregion

    // #region Contact Form
    if ($('._js-contact-form').length) {
        $('._js-contact-form').each(function() {
            var cForm = $(this)

            cForm.on('submit', function(ev) {
                ev.preventDefault()
                //var nonce = cForm.find('.contactFormNonce').val();
                cForm.find('input[type=submit]').prop('disabled', true)
                cForm.find('.status').addClass('loading')

                console.log('serialized form data', cForm.serialize())

                $.ajax({
                    method: 'POST',
                    dataType: 'text',
                    url: myAjax.ajaxurl,
                    data: cForm.serialize(),
                    cache: false,
                    error: function(err) {
                        console.log(err)
                    },
                    success: function(response) {
                        cForm
                            .find('.status')
                            .removeClass('loading')
                            .addClass('done')
                            .find('.msg')
                            .text(response)
                    },
                })
            })
        })
    }

    $(window).scroll(function () {
        // var windowHeight = $(window).height();
        // var scrolltop = $(this).scrollTop();
        // var percentage = (100/windowHeight) * scrolltop;
        // console.log(percentage);
        // if(scrolltop < $(window).height()) {
        //     if($(window).width() > 768) {
        //         $('.home .pageBanner.h-full').css({ 'background-position':'center '+ (50 - percentage) +'%'});
        //         $('.single-case_study .hero-text.h-full').css({ 'background-position':'center '+ (50 - percentage) +'%'});
        //     }
        // }
		// $(".parallaxobj").each(function() {
		// 	if(verge.inViewport($(this))){
		// 		$(this).addClass('animated');
		// 	}
		// 	else {
		// 		$(this).removeClass('animated');
		// 	}
        // });
        
        if($('#counter').length > 0) {
            if(verge.inViewport($('#counter'))){
                $('.counter').each(function() {
                    var $this = $(this),
                        countTo = $this.attr('data-count');
                
                    $({ countNum: $this.text()}).animate({
                    countNum: countTo
                    },
                
                    {
                
                    duration: 500,
                    easing:'linear',
                    step: function() {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function() {
                        $this.text(this.countNum);
                    }
                    });
                });
            }
        }
    });
    
    // #endregion

    // $(window).scroll(function(){
    //     if($(this).scrollTop() > 300) {
    //         $('.stickyBanner').css({ 'opacity' : 0 });
    //     }
    //     else {
    //         $('.stickyBanner').css({ 'opacity' : 1-$(this).scrollTop()/300 });
    //     }
    // });

    function cloneHeaderElements() {
        $('.nav-master .logo.header svg')
            .clone()
            .appendTo('.siteHeader .logo.nav')

        $('.nav-master ._toggleNav')
            .clone()
            .appendTo('.siteHeader .nav-control')
    }
    cloneHeaderElements();

    $(window).on('load', function(){        

        if($('._js-bricks').length > 0) {
            $('._js-bricks').masonry({
                columnWidth: '.newsBlock-sizer',
                itemSelector: '.newsBlock',
            });
        }

        if($('.projects .fg').length > 0) {
            $('.projects .fg').masonry({
                columnWidth: '.projects .fg .fgi',
                itemSelector: '.projects .fg .fgi',
            });
        }
    });    

    $(".stickyBanner a").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
          // Prevent default anchor click behavior
          event.preventDefault();
    
          // Store hash
          var hash = this.hash;
    
          // Using jQuery's animate() method to add smooth page scroll
          // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
          $('html, body').animate({
            scrollTop: $(hash).offset().top
          }, 800, function(){
    
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          });
        } // End if
      });

    // var layout_bricks
    // if ($('._js-bricks').length) {
    //     const bricks_sizes = [{
    //         columns: 2,
    //         gutter: 40
    //     }]
    //     layout_bricks = Bricks({
    //         container: '._js-bricks',
    //         packed: 'data-packed',
    //         sizes: bricks_sizes,
    //         resize: true,
    //     })
    // }

    // #region toggle menu
    $('._toggleNav').on('click', function(e) {
        var navTransitionTime = 500
        e.preventDefault()
        if ($('body').hasClass('nav-open')) {
            $('body').removeClass('nav-open')
            window.setTimeout(function() {
                $('body').removeClass('nav-opening')
            }, navTransitionTime)
        } else if ($('body').hasClass('nav-opening')) {
            $('body').removeClass('nav-opening')
        } else {
            $('body').addClass('nav-opening')
            window.setTimeout(function() {
                $('body').addClass('nav-open')
            }, navTransitionTime)
        }
    })
    // #endregion    

    // #region video controls
    $('[data-playVideoID]').on('click', function() {
        var video = $('#' + $(this).attr('data-playVideoID'))
        video.addClass('playing').prop('controls', true)
        video[0].play()
        video.on('pause ended', function() {
            video.removeClass('playing').prop('controls', false)
        })
    })
    // #endregion

    // #region Accordions
    // $('.accordion-header a').on('click', function(e) {
    //     e.preventDefault()
    //     var acc = $(this).closest('.accordion')
    //     acc.toggleClass('open')
    // })

    // $('.accordion .preopen').each(function() {
    //     $(this).addClass('open')
    //     $(this)
    //         .find('.accordion-header a')
    //         .off('click')
    //         .on('click', function(e) {
    //             e.preventDefault()
    //         })
    //     $(this)
    //         .find('.accordion-toggle')
    //         .hide()
    // })

    // $('.accordions[data-focus]').each(function() {
    //     var focusItem = $(this).attr('data-focus')
    //     var focusItemClick = $(this).find(
    //         '.accordion-title a[href="#' + focusItem + '"]'
    //     )
    //     focusItemClick.trigger('click')
    //     scrollWindow(focusItemClick)
    // })

    // if ($('.accordions.large').length) {
    //     $('.accordions.large').each(function() {
    //         var t = $(this)
    //         if (t.find('>.accordion').length == 1)
    //             t.find('>.accordion').addClass('open')
    //     })
    // }
    // #endregion

    // #region Lock the footer
    function lockFooter() {
        if ($('.siteFooter._js-lock').length) {
            var footerHeight = $('.siteFooter').outerHeight()
            $('.siteFooter').addClass('locked')
            $('body').css('margin-bottom', footerHeight + 'px')
        }
    }
    // #endregion

    // #region Lock stickyBanners
    function lockHeader() {
        var bannerHeight = $('.stickyBanner').outerHeight()
        //console.log('bannerHeight', bannerHeight)
        $('.stickyBanner').addClass('locked')
        $('body').css('margin-top', bannerHeight + 'px')
    }
    // #endregion

    // #region Anchor x positions of floating elements
    function anchorElementsX() {
        var myX, myXDiff, master_x
        var master_rx
        if ($('.logo.header').length) {
            // first, get the logo left edge - this is the marker for everything else
            master_x = $('.logo.header').offset().left
            //console.log('master_x', master_x)
            $('.pageBanner:not(._rev, .plain) .section-content').each(function(
                el
            ) {
                if ($(this).attr('data-origX')) {
                    myX = $(this).attr('data-origX')
                } else {
                    myX = $(this).offset().left
                    $(this).attr('data-origX', myX)
                }
                myXDiff = master_x - myX
                $(this).css('transform', 'translateX(' + myXDiff + 'px)')
            })
        }

        if ($('.nav-master .nav-control').length) {
            // first, get the logo left edge - this is the marker for everything else
            master_rx =
                $('.nav-master .nav-control').offset().left +
                $('.nav-master .nav-control').width()
            $('.pageBanner._rev .section-content').each(function(el) {
                if ($(this).attr('data-origX')) {
                    myX = $(this).attr('data-origX')
                } else {
                    myX = $(this).offset().left + $(this).width()
                    $(this).attr('data-origX', myX)
                }
                myXDiff = master_rx - myX
                $(this).css('transform', 'translateX(' + myXDiff + 'px)')
            })
        }
    }
    // #endregion

    // only do this one desktop (below)

    // #region replace images
    function replaceImgs() {
        $('.imgReplace').each(function(e) {
            var iurl = $(this).data('imgreplace')
            $(this).attr('src', iurl)
            if ($(this).attr('src') !== iurl) $(this).attr('src', iurl)
        })
    }
    replaceImgs()
    // #endregion

    // #region scroll functions
    var pageHeight = $(document).height()
    var windowHeight = $(window).height()

    function scrollEvents() {

        currentScrollTop = $(this).scrollTop()
        currentScrollBottom = currentScrollTop + $(window).height()

        //console.log("Running scroll events", currentScrollTop);

        if (currentScrollTop < 10) {
            $('body').removeClass('scrollUp isScrolled scrollDown navOnScreen isPageDown')
            stuck = false

            return
        } else {
            if (!stuck) {
                stuck = true
                $('body').addClass('isScrolled')
            }
        }

        if (
            currentScrollTop > lastScroll &&
            !$('body').hasClass('scrollDown')
        ) {
            // down
            $('body')
                .removeClass('scrollUp')
                .addClass('scrollDown')
        } else if (
            currentScrollTop < lastScroll &&
            $('body').hasClass('scrollDown')
        ) {
            // up
            $('body')
                .removeClass('scrollDown')
                .addClass('scrollUp')
        }
        lastScroll = currentScrollTop

        // is scroll beyond half the page?
        if (currentScrollTop < pageHeight / 2) {
            $('body').removeClass('scrolledHalf')
        } else {
            $('body').addClass('scrolledHalf')
        }

        // is scroll beyond half the page?
        if (currentScrollTop > 100) {
            if (!$('body').hasClass('isPageDown')) {
                $('body').addClass('isPageDown')
                window.setTimeout(function() {
                    $('body').addClass('navOnScreen')
                }, 50)
            }
        } else {
            $('body').removeClass('isPageDown navOnScreen')
        }
    }
    $(window).scrolled(scrollEvents)
    window.setInterval(scrollEvents, 500);

    function scrollWindow(target) {
        $('html, body').animate({
                scrollTop: $(target).offset().top - 64,
            },
            200
        )
    }

    $('a.scrollTo').on('click', function(e) {
        e.preventDefault()
        scrollWindow($(this).attr('href'))
    })
    // #endregion

    // #region intersection functions
    /*
     ** INTERSECTION - BASIC
     */
    // function onIntersection(entries) {
    //     for (var i = 0, item;
    //         (entry = entries[i]); i++) {
    //         if (entry.isIntersecting) {
    //             $(entry.target).addClass('intersect')
    //         } else {
    //             $(entry.target).removeClass('intersect')
    //         }
    //     }
    // }

    // var basicIntersectionEls = $('._intersection')

    // var observer = new IntersectionObserver(onIntersection)
    // basicIntersectionEls.each(function(index) {
    //     observer.observe($(this)[0])
    // })
    // #endregion

    // #region tabs/toggle functions
    $('.toggleEl').on('click', function(e) {
        e.preventDefault()
        //console.log($(this).attr('href'))
        $($(this).attr('href')).slideToggle()
    })
    $('.toggleEl.autoHide').each(function() {
        var elToHide = $(this).attr('href')
        $(elToHide).hide()
    })

    $('.tabs').each(function(el) {
        var tab = $(this)
        tab.find('.tab-content').hide()
        tab.find('.tabNav a').on('click', function(e) {
            e.preventDefault()
            tab.find('li.active').removeClass('active')
            $(this)
                .parent()
                .addClass('active')
            tab.find('.tab-content').hide()
            var target = $(this).attr('href')
            $(target).fadeIn()
        })

        tab.find('.tabNav li:eq(0) a').click()
    })
    // #endregion

    $('[data-bg]').each(function() {
        $(this).css('background-image', 'url(' + $(this).data('bg') + ')');
    })

    // #region responsive functions
    function _mq_phoneChanged(_mq_isPhone) {
        if (_mq_isPhone.matches) {
            // console.log('_mq_', 'is phone');

            if ($('.touch-carousel-x1').length) {
                $('.touch-carousel-x1').each(function() {
                    var c = $(this);
                    if (!c.hasClass('slick-initialized')) {
                        c.slick({
                            rows: 4,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            mobileFirst: true,
                            dots: true,
                            infinite: true,
                            autoplay: true,
                        });
                    }
                });
            }

            $('[data-bg-mobile]').each(function() {
                $(this).css('background-image', 'url(' + $(this).data('bg-mobile') + ')');
            })
        } else {
            // console.log('_mq_', 'is not phone');

            if ($('.touch-carousel-x1').length) {
                $('.touch-carousel-x1').each(function() {
                    var c = $(this);
                    if (c.hasClass('slick-initialized')) {
                        c.slick('unslick');
                    }
                });
            }
        }
    }

    function _mq_tabletChanged(_mq_isTablet) {
        if (_mq_isTablet.matches) {
            // console.log('_mq_', 'is tablet');
            $('[data-bg]').each(function() {
                $(this).css('background-image', 'url(' + $(this).data('bg') + ')');
            })
        } else {
            // console.log('_mq_', 'is not tablet');
        }
    }

    function _mq_touchChanged(_mq_isTouch) {
        if (_mq_isTouch.matches) {
            //console.log('_mq_', 'is touch');


        } else {


            // if ($('._js-bricks').length) {
            //     layout_bricks.pack()
            // }
            // lockFooter()
            // lockHeader()
            anchorElementsX()
        }
    }

    function _mq_laptopUp(_mq_isLaptopUp) {
        if (_mq_isLaptopUp.matches) {
            console.log('_mq_', 'is laptop')

            $('[data-bg]').each(function() {
                $(this).css('background-image', 'url(' + $(this).data('bg') + ')');
            })

            // #region split (flex columns) functions
            $('._js-split-2').each(function(el) {
                var orig_classes = $(this).attr('class')
                // count the list items
                var lis = $(this).find('>li').length
                var lis_split = Math.ceil(lis / 2)
                var fg = $('<div class="fg fg-2"></div>')
                var list_1 = $('<ul class="' + orig_classes + '"></ul>')
                var list_2 = $('<ul class="' + orig_classes + '"></ul>')
                $(this)
                    .find('>li')
                    .slice(0, lis_split)
                    .appendTo(list_1)
                $(this)
                    .find('>li')
                    .slice(0)
                    .appendTo(list_2)
                fg.append(
                    $('<div class="fgi"></div>').html(list_1),
                    $('<div class="fgi"></div>').html(list_2)
                )
                $(this)
                    .before(fg)
                    .remove()
            })

            $('.paragraph-group-js').each(function(el) {
                //var orig_classes = $(this).attr('class');
                // count the list items
                var els = $(this).find('>*').length
                var els_split = Math.ceil(els / 2)
                var fg = $('<div class="_js-paragraph-group fg fg-2"></div>')
                var col_1 = $('<div class="gfi _js-pGroupEl"></div>')
                var col_2 = $('<div class="gfi _js-pGroupEl"></div>')
                console.log('els', els)
                if (els > 1) {
                    $(this)
                        .find('>*')
                        .slice(0, els_split)
                        .appendTo(col_1)
                    $(this)
                        .find('>*')
                        .slice(0)
                        .appendTo(col_2)
                    fg.append(col_1, col_2)
                    $(this)
                        .before(fg)
                        .remove()
                } else {
                    $(this).addClass('text-centered limited_w_s')
                }
            })
            // #endregion

            window.onresize = function() {
                console.log('RESIZE')
                // lockFooter()
                // lockHeader()
                anchorElementsX()
            }
        } else {
            console.log('_mq_', 'is not laptop');
        }
    }

    if (matchMedia) {
        // console.log("matchMedia is a go");
        // _dw = device widths
        var _dw = {
            phone: {
                min: 0,
                max: 680,
            },
            tablet: {
                min: 681,
                max: 1020,
            },
            laptopUp: {
                min: 1021
            }
        }

        var _mq_isPhone = window.matchMedia(
            '(max-width: ' + _dw.phone.max + 'px)'
        )
        _mq_isPhone.addListener(_mq_phoneChanged)

        var _mq_isTablet = window.matchMedia(
            '(min-width: ' +
            _dw.tablet.min +
            'px) AND (max-width: ' +
            _dw.tablet.max +
            'px)'
        )
        _mq_isTablet.addListener(_mq_tabletChanged)

        var _mq_isTouch = window.matchMedia(
            '(max-width: ' + _dw.tablet.max + 'px)'
        )
        _mq_isTouch.addListener(_mq_touchChanged)

        var _mq_isLaptopUp = window.matchMedia(
            '(min-width: ' +
            _dw.laptopUp.min +
            'px)'
        )
        _mq_isLaptopUp.addListener(_mq_laptopUp)

        _mq_phoneChanged(_mq_isPhone)
        _mq_touchChanged(_mq_isTouch)
        _mq_laptopUp(_mq_isLaptopUp)

        $(window).trigger('resize')
    }
    // #endregion       

    var gf_active_page = 0;
    jQuery('.gform_page').addClass('active');

    function setPage(current_page, form_id) {
        setTimeout(function() {
            jQuery('.gform_wrapper .gform_page').removeClass('active');
            if(current_page > gf_active_page) {
                jQuery('.gform_wrapper #gform_page_'+form_id+'_'+current_page).addClass('animated fadeInUp active slideRight').delay(1000).addClass('active');
                jQuery('html, body').animate({ scrollTop: 0 }, 1000);
            }
            else {
                jQuery('.gform_wrapper #gform_page_'+form_id+'_'+current_page).addClass('animated fadeInUp active slideLeft').delay(1000).addClass('active');
                jQuery('html, body').animate({ scrollTop: 0 }, 1000);
            }
            gf_active_page = current_page;
        }, 100);
    }

    jQuery(document).bind('gform_page_loaded', function(event, form_id, current_page) {
        if(!$('#gform_wrapper_'+form_id).hasClass('gform_validation_error')) {
            if(gf_active_page != current_page) { 
                setPage(current_page, form_id);
            } 
            else {
                jQuery('.gform_wrapper #gform_page_'+form_id+'_'+current_page).addClass('active');
            }        
        }        
        else {
            jQuery('.gform_wrapper #gform_page_'+form_id+'_'+current_page).addClass('active');
        }        
    });
})